import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgFontSize(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.456 15H5.08l-1.964 5H1L7.286 4H9.25l6.286 16H13.42l-1.964-5Zm-.786-2L8.268 6.885 5.866 13h4.804Zm10.366-.465V12H23v8h-1.964v-.535A3.857 3.857 0 0 1 19.07 20c-2.17 0-3.928-1.79-3.928-4s1.759-4 3.928-4c.716 0 1.387.195 1.965.535ZM19.07 18c1.085 0 1.965-.895 1.965-2s-.88-2-1.965-2c-1.084 0-1.964.895-1.964 2s.88 2 1.964 2Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgFontSize)
